import {
  AccountDealTypeListData,
  AccountDealTypePayload,
  AccountDetailsData,
  AccountDetailsListPayload,
  AccountTotalData,
  AccountTotalPayload,
  AccountTypeListData,
  BettingRecordData,
  CategoryComboData,
  CenterGetBettingRecordListPayload,
  CenterGetCategoryComboPayload,
  PersonalStatementListData,
  PersonalStatementListPayload,
  PersonalStatementListV1Payload,
  SettleStatusEnum
} from './type'
import { GlobalService } from '@/context'
import { merge } from 'lodash'

/**
 * @description 获取投注记录列表
 * @param payload
 * @returns
 */
export const apiCenterGetBettingRecordList = (
  payload: CenterGetBettingRecordListPayload
) => {
  const oc = merge(
    {
      current: 1,
      gameCategoryId: 0,
      gameIds: 0,
      platformId: 0,
      settleTimeEnd: 0,
      settleTimeStart: 0,
      settleStatus: SettleStatusEnum.ALL,
      size: 20
    },
    payload
  )
  return GlobalService.post<{ data: Array<BettingRecordData>; total: number }>({
    url: '/api/bet-manager/recentreport/betrecords/_query',
    data: oc
  })
}

/**
 * @description 获取游戏类型的组合接口
 * @param payload
 * @returns
 */
export const apiCenterGetCategoryCombo = (
  payload: CenterGetCategoryComboPayload = {
    platformId: null,
    gameCategoryId: null
  }
) => {
  payload.gameCategoryId =
    payload.gameCategoryId === 0 ? null : payload.gameCategoryId
  payload.platformId = payload.platformId === 0 ? null : payload.platformId
  return GlobalService.post<CategoryComboData>({
    url: '/api/game/recentreport/platform-category-game-combo',
    data: payload
  })
}

/**
 * @description 获取个人中心个人报表[非分页]
 * @param payload
 * @returns
 */
export const apiCenterGetPersonalStatementListV1 = (
  payload: PersonalStatementListV1Payload
) => {
  return GlobalService.post<Array<PersonalStatementListData>>({
    url: '/api/bet-manager/recentreport/bet_report/personal/_query',
    data: payload
  })
}

/**
 * @description 获取个人中心个人报表
 * @param payload
 * @returns
 */
export const apiCenterGetPersonalStatementList = (
  payload: PersonalStatementListPayload
) => {
  return GlobalService.post<{
    data: Array<PersonalStatementListData>
    total: number
  }>({
    url: '/api/bet-manager/recentreport/bet_report/personal/v2/_query',
    data: payload
  })
}

/**
 * @description 获取个人中心账单明细列表
 * @param payload
 * @returns
 */
export const apiCenterGetAccountDetailsList = (
  payload: AccountDetailsListPayload
) => {
  return GlobalService.post<{ total: number; data: Array<AccountDetailsData> }>(
    {
      url: '/user/accountPageList',
      data: payload
    }
  )
}

/**
 * @description 获取个人中心个人用户相各类余额
 * @param payload
 * @returns
 */
export const apiCenterGetAccountStatistics = (payload: AccountTotalPayload) => {
  return GlobalService.post<AccountTotalData>({
    url: '/user/accountTotal',
    data: payload
  })
}

/**
 * @description 获取账户类型枚举
 * @param payload
 * @returns
 */
export const apiCenterGetAccountType = () => {
  return GlobalService.get<AccountTypeListData>({
    url: '/home/opt_type_v2',
    customParams: {
      tryStaticMode: true,
      cache: true,
      staticKeyOmit: ['platformType', 'currency'],
      keyOmit: true
    }
  })
}

/**
 * @description 获取查询账变小类
 * @param payload
 * @returns
 */
export const apiCenterGetAccountDealType = (
  payload: AccountDealTypePayload
) => {
  return GlobalService.post<AccountDealTypeListData>({
    url: '/home/dealType',
    data: payload
  })
}
